import filterRemoveEmail from './filterRemoveEmail'
import filterRemoveSite from './filterRemoveSite'
import filterRemovePhone from './filterRemovePhone'

function filterRemoveEmailSitePhone(text: string, intensity: string, allowedHosts: string[] = []) {
  const isHard = intensity === 'hard'

  return filterRemovePhone(filterRemoveSite(filterRemoveEmail(text), allowedHosts), isHard)
}

export default filterRemoveEmailSitePhone
